import {
  Button,
  Col,
  Icon,
  Layout,
  Row,
  Spin,
  Table,
  Tag,
  Select,
  Alert,
  notification,
} from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchMenuAction } from "../../../store/actions/leftSideMenu";
import SearchForm from "../../SearchForm";
import "../style.css";
import services from "./service";
import column from "./column";
import EntryModal from "./entry-modal";
import UserSearchForm from "../../User/user-search-form";

const { Content } = Layout;

class WhitelistURL extends Component {
  state = {
    configurations: [],
    dataSource: [],
    limit: 10,
    total: 0,
    currentPage: 1,
    searchMemberID: 0,

    showTopic: false,
    currentConfiguration: null,
    loading: false,

    visibleEntryModal: false,
    currentData: {},
  };

  columnsMobile = [];

  componentWillMount() {
    this.props.fetchMenuAction("keyword", "keyword-whitelist-url");
    this.setState({ loading: true });
  }

  async componentDidMount() {
    this.setState({
      configurations: await services._getConfigurationList("url_allowed"),
      loading: false,
    });
  }

  onCreate = () => {
    this.setState({
      isModify: false,
      currentData: {},
      visibleEntryModal: true,
    });
  };

  onDelete = async (record) => {
    this.setState({
      loading: true,
    });
    try {
      await services._deleteWhitelistURL(record.id);
    } catch (error) {
      notification.error({
        message: "Deleting Data Error",
        description: `Something went wrong on request: ${JSON.stringify(
          error
        )}`,
      });
    }

    await this.fetchMemberWL(
      this.state.currentConfiguration.Id,
      this.state.currentPage,
      this.state.limit,
      this.state.searchMemberID
    );

    this.setState({
      loading: false,
    });
  };

  onUpdate = async (record) => {
    this.setState({
      isModify: true,
      currentData: record,
      visibleEntryModal: true,
    });
  };

  fetchMemberWL = async (configID, page, limit, memberID) => {
    const data = await services._getWhitelistURList(
      configID,
      page,
      limit,
      memberID
    );
    this.setState({
      dataSource: data.data,
      total: data.total_rows,
      currentPage: data.page,
      limit: data.limit,
    });
  };

  formHandleCancel = () => {
    this.setState({
      isModify: false,
      currentData: {},
      visibleEntryModal: false,
    });
  };
  formHandleSubmit = (form) => {
    this.setState({
      loading: true,
    });

    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }

      try {
        if (this.state.isModify) {
          await services._updateWhitelistURL(this.state.currentData.id, values);
        } else {
          await services._createWhitelistURL(
            this.state.currentConfiguration.Id,
            values
          );
        }
      } catch (error) {
        notification.error({
          message: "Submit Data Error",
          description: `Something went wrong on request:  ${JSON.stringify(
            error
          )}`,
        });
      }

      await this.fetchMemberWL(
        this.state.currentConfiguration.Id,
        this.state.currentPage,
        this.state.limit,
        this.state.searchMemberID
      );

      this.setState({
        loading: false,
        visibleEntryModal: false,
        currentData: {},
      });

      form.resetFields();
    });
  };

  onHandleConfigurationIdChanges = async (val) => {
    if (!val) {
      return;
    }

    this.setState({
      currentConfiguration: val,
      showTopic: true,
      loading: true,
    });

    await this.fetchMemberWL(
      val.Id,
      this.state.currentPage,
      this.state.limit,
      this.state.searchMemberID
    );

    this.setState({
      loading: false,
    });
  };
  changePage = async (page) => {
    this.setState({
      currentPage: page,
      loading: true,
    });

    await this.getDataList(page, this.state.currentSearch);

    this.setState({
      flagStatusToggle: this.setFlagStatusToggle(),
      loading: false,
    });
  };

  onChangePage = async (page) => {
    this.setState({
      currentPage: page,
      loading: true,
    });

    await this.fetchMemberWL(
      this.state.currentConfiguration.Id,
      page,
      this.state.limit,
      this.state.searchMemberID
    );
    this.setState({
      loading: false,
    });
  };

  onSearchMemberID = async (memberID) => {
    this.setState({
      searchMemberID: memberID,
      loading: true,
    });

    await this.fetchMemberWL(
      this.state.currentConfiguration.Id,
      this.state.currentPage,
      this.state.limit,
      memberID
    );

    this.setState({
      loading: false,
    });
  };

  render() {
    const propsTable = {
      bordered: true,
      className: "my-table",
      columns: column(this.onUpdate, this.onDelete),
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        pageSize: this.state.limit,
        total: this.state.total,
        current: this.state.currentPage,
        onChange: this.onChangePage,
        size: "small",
      },
      size: "small",
    };
    const propsTableForMobile = Object.assign({}, propsTable);

    propsTableForMobile.className = "my-table-mobile";
    propsTableForMobile.columns = this.columnsMobile;

    return (
      <Layout className="my-layout">
        <Spin spinning={this.state.loading} tip="State are loading...">
          <Content
            style={{
              background: "#fff",
              padding: 24,
              margin: "16px 0",
              minHeight: 300,
            }}
          >
            <h2>Whitelist URL</h2>
            <p className="header-desc">
              A list of members allowed to send messages with URLs.
            </p>
            <Row>
              <Col
                style={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                }}
                span={24}
              >
                {this.state.showTopic && (
                  <Alert
                    showIcon
                    message="Configuration Note"
                    description={
                      <div>
                        <ul
                          style={{
                            listStyleType: "none",
                          }}
                        >
                          <li>Topic: {this.state.currentConfiguration.Item}</li>
                          <li>
                            Country:{" "}
                            {this.state.currentConfiguration.CountryAbbr}
                          </li>
                          <li>
                            Status:{" "}
                            {this.state.currentConfiguration.Value ===
                            "inactive" ? (
                              <Tag color="red">Block</Tag>
                            ) : (
                              <Tag color="green">Not Block</Tag>
                            )}
                          </li>
                        </ul>
                      </div>
                    }
                    type="info"
                  />
                )}
              </Col>
            </Row>
            <Row className="utility-bar" style={{ marginBottom: "12px" }}>
              <Col span={12}>
                <Button
                  className="add-btn"
                  onClick={() => this.onCreate()}
                  disabled={!this.state.showTopic}
                >
                  <Icon type="plus-circle" />
                  Add
                </Button>
              </Col>
              <Col span={12} style={{ textAlign: "end" }}>
                <UserSearchForm
                  valueCallback={this.onSearchMemberID}
                  value={this.state.searchMemberID}
                  disabled={!this.state.showTopic}
                  style={{ width: "200px", marginRight: "10px" }}
                />
                <Select
                  showSearch
                  placeholder="Select Country"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  style={{ width: "200px" }}
                  onChange={(val) => this.onHandleConfigurationIdChanges(val)}
                >
                  {(!this.state.loading && this.state.configurations
                    ? this.state.configurations
                    : []
                  ).map((item, i) => (
                    <Option key={i} value={item}>
                      {item.CountryAbbr}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
            <Row className="utility-bar-mobile">
              <Button
                block
                onClick={() => this.onCreate()}
                disabled={!this.state.showTopic}
              >
                <Icon type="plus-circle" />
                Add
              </Button>
            </Row>
            <Row className="utility-bar-mobile">
              <SearchForm fn={this.mySearch} fnReset={this.resetSearch} />
            </Row>
            <Table {...propsTable} />
            <Table {...propsTableForMobile} />
            <EntryModal
              visible={this.state.visibleEntryModal}
              isModify={this.state.isModify}
              loading={this.state.loading}
              onCancel={this.formHandleCancel}
              onCreate={this.formHandleSubmit}
              data={this.state.currentData}
              existingData={this.state.dataSource}
            />
          </Content>
        </Spin>
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

export default connect(null, mapDispatchToProps)(WhitelistURL);



// WEBPACK FOOTER //
// ./src/containers/Keyword/WhitelistURL/index.js